import { render, staticRenderFns } from "./BatchTestResultsContentNodeId.vue?vue&type=template&id=47d8e17e&scoped=true&"
import script from "./BatchTestResultsContentNodeId.vue?vue&type=script&lang=js&"
export * from "./BatchTestResultsContentNodeId.vue?vue&type=script&lang=js&"
import style0 from "./BatchTestResultsContentNodeId.vue?vue&type=style&index=0&id=47d8e17e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d8e17e",
  null
  
)

export default component.exports